export const SlurryFormData = [
  {
    formControl: 'slurrySet',
    legend: $localize`Slurry Set`,
    options: [
      { label: $localize`10 meter, 30 m³ tank volume`, value: '10' },
      { label: $localize`20 meter, 30 m³ tank volume`, value: '20' },
      { label: $localize`30 meter, 30 m³ tank volume`, value: '30' },
    ],
  },
  {
    formControl: 'applicationRate',
    legend: $localize`Application Rate`,
    options: [
      { label: $localize`10 t/ha`, value: '10' },
      { label: $localize`20 t/ha`, value: '20' },
      { label: $localize`30 t/ha`, value: '30' },
    ],
  },
  {
    formControl: 'variation',
    legend: $localize`Allowed Variation`,
    options: [
      { label: $localize`0%`, value: '0' },
      { label: $localize`+/- 10%`, value: '1' },
      { label: $localize`+/- 20%`, value: '2' },
    ],
  },
];
